import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Header from "../../../components/Headers/Header";
import { Card, CardHeader, Container, Row,  Button, Modal,ModalHeader } from "reactstrap";
import { getAll } from "../../../network/ApiAxios";
import EditUserFullModal from '../EditUserFullModal'

import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import EditEmp from "./EditEmpModal";

const empTable = () => {
  console.log('first')
  const history = useHistory();
  const [users, setUsers] = useState();
  const [reload, setReload] = useState('');
  const [modal, setModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState();

  const toggle = () => setModal(!modal);
  
  useEffect(() => { 
    const runAsync = async () => {
      const response = await getAll("empTable");
      const { data } = response;
      if (data.success) {
        birthToAge(data.users);
        setUsers(data.users);
      }
    };
    runAsync();
  }, [reload]);

  async function editUser(e) {
    var useID = e.data._id;
    history.push("/admin/edituserfull", useID);
  }

  const birthToAge = (users) => {
    if (users) {
      users.map((user) => {
        if (user.birthday === "0000-00-00") {
          // calculate age
          users.birthday = "Nannn";
        } else {
          var today = new Date();
          var birthDate = new Date(user.birthday);
          var agecalc = today.getFullYear() - birthDate.getFullYear();
          var m = today.getMonth() - birthDate.getMonth();
          if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            agecalc--;
          }
          user.birthday = agecalc;
        }
        return users
      });
    }
  };

  const getRowStyle = (params) => {
    if (params.node.rowIndex % 2 === 0) {
      return { background: "aliceblue" };
    }
  };

  const dynamicCellStyle = (params) => {
    if (params.value === false) {
      return { backgroundColor: "red" };
    } else {
      return { backgroundColor: "greenyellow" };
    }
  };
  const [gridApi, setGridApi] = useState(null);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  const activeFilter = (params) => {
    setUsers(users.filter((user)=>{
      return user.active
    }))
    gridApi.setQuickFilter("jobapp");
  };
  const resetFilter = (params) => {
    setReload(true)
    gridApi.setQuickFilter("");
  };

  const editUserModal = (e)=>{
    setSelectedUser(e.data._id)
    toggle()
  }

  return (
    <>
      <Header />
      <Container>
        <Row>
          <div className="col">
            <Card className="shadow" style={{ width:"100%"}}>
              <CardHeader>
                <Button onClick={activeFilter}>Filter active users</Button>
                <Button onClick={resetFilter} className="float-right btn-danger" >Reset filter</Button>
              </CardHeader>
              <div className="ag-theme-alpine" style={{ height: 500, width:"100%"}}>
              
                <AgGridReact
                  rowData={users}
                  animateRows={true}
                  onRowDoubleClicked={editUser}
                  onRowClicked={editUserModal}
                  pagination={true}
                  paginationPageSize={20}
                  getRowStyle={getRowStyle}
                  onGridReady={onGridReady}
                  defaultColDef={{
                    flex: 1,
                    filter: true,
                    sortable: true,
                    floatingFilter: true,
                    columnHoverHighlight: true,
                    resizable: true,
                    suppressDragLeaveHidesColumns: false,
                  }}
                >
                  
                  <AgGridColumn field="name" minWidth="170" style={{textAlign:"center"}}></AgGridColumn>
                  <AgGridColumn field="email" minWidth="200"></AgGridColumn>
                  <AgGridColumn field="role" minWidth="100" quickFilterText></AgGridColumn>
                  <AgGridColumn field="house" minWidth="120"></AgGridColumn>
                  <AgGridColumn field="accomodation" minWidth="140"></AgGridColumn>
                  <AgGridColumn
                    field="birthday"
                    headerName="Age"
                    filter="agNumberColumnFilter"
                    minWidth="80"
                  ></AgGridColumn>
                  <AgGridColumn
                    field="active"
                    cellStyle={dynamicCellStyle}
                    minWidth="90"
                  ></AgGridColumn>
                  <AgGridColumn field="cardID" minWidth="130"></AgGridColumn>
                  <AgGridColumn field="manager.name" minWidth="150"></AgGridColumn>
                </AgGridReact>
              </div>
            </Card>
          </div>
        </Row>
      <Modal isOpen={modal} toggle={toggle} style={{maxWidth:'75%'}} >
        <ModalHeader toggle={toggle} close={<button className="close" onClick={toggle} type="button"> &times;</button>} ></ModalHeader>
        
        <EditEmp userID={selectedUser}/>
      </Modal>
      </Container>
    </>
  );
};

export default empTable;
